export const COMPANY = {
  name: "MIM Engineering",
  tagline: "Precision Machining. Quality Fabrication. End-to-End Engineering.",
  address: "10 Wright Street, Bayswater WA 6053",
  phone: "(08) 9371 9545",
  email: "workshop@mimeng.com.au",
  hours: "Mon – Fri · 7:00am – 4:00pm",
};

export const VALUE_PROPS = [
  { title: "High Quality", desc: "Workmanship measured against calibrated instruments and signed-off before it leaves the floor." },
  { title: "Fast Turnaround", desc: "Local Bayswater workshop responding to urgent breakdowns and minimising downtime." },
  { title: "Reliable Service", desc: "Skilled tradespeople, transparent communication, end-to-end accountability." },
];

export const SERVICES = [
  {
    id: "machining",
    number: "01",
    title: "Machining",
    short: "CNC turning & milling, manual lathes, boring and shaft repairs.",
    image: "/uploads/mim-machined-bracket.jpg",
    bullets: [
      "CNC turning & milling (Okuma & Haas)",
      "Manual lathes & milling machines",
      "Horizontal & vertical boring",
      "Shaft repairs & reconditioning",
      "Clutch and gearbox housing machining",
      "Custom one-off & low volume parts",
    ],
  },
  {
    id: "fabrication",
    number: "02",
    title: "Fabrication",
    short: "General metal, structural repairs, MIG/TIG/Stick welding.",
    image: "https://images.unsplash.com/photo-1641893823219-38b433f736c0?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    bullets: [
      "General metal fabrication",
      "Structural repairs & modifications",
      "Chutes, guards, frames & brackets",
      "MIG, TIG and Stick welding",
      "Steel, stainless steel & aluminium",
    ],
  },
  {
    id: "fitting",
    number: "03",
    title: "Fitting & Assembly",
    short: "Bearings, sheaves, gearbox & equipment assembly.",
    image: "/uploads/mim-shaft-rebuild-1.jpg",
    bullets: [
      "Bearing fitting & replacement",
      "Sheaves repair & machining",
      "Parts assembly for Tier-1 civil construction brands",
      "Gearbox & equipment assembly",
      "Mechanical fitting",
    ],
  },
  {
    id: "motor",
    number: "04",
    title: "Motor Components",
    short: "End shields, housings, shafts and rotor/stator work.",
    image: "/uploads/mim-crankshaft.jpg",
    bullets: [
      "End shields & housings",
      "Shafts & bearing housings/covers",
      "Rotor & stator related machining",
      "Precision tolerances on motor parts",
    ],
  },
  {
    id: "finishing",
    number: "05",
    title: "Surface Finishing",
    short: "Powder coating for durability and protection.",
    image: "https://images.unsplash.com/photo-1564182998523-6923112e7d6b?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    bullets: [
      "Powder coating",
      "Surface preparation",
      "Coordinated machine, fabricate, coat & assemble packages",
    ],
  },
  {
    id: "inspection",
    number: "06",
    title: "Inspection & Quality",
    short: "Dimensional and visual inspection with calibrated instruments.",
    image: "https://images.unsplash.com/photo-1501516069922-a9982bd6f3bd?crop=entropy&cs=srgb&fm=jpg&w=1400&q=85",
    bullets: [
      "Dimensional & visual inspection",
      "Calibrated measuring equipment",
      "Quality assurance documentation",
      "Hardness testing",
    ],
  },
];

export const INDUSTRIES = [
  { id: "waste", title: "Waste & Recycling", image: "https://images.unsplash.com/photo-1720036237182-5e0adada1873?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" },
  { id: "transport", title: "Transport & Fleet Maintenance", image: "https://images.unsplash.com/photo-1698664683348-f9f35b809821?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" },
  { id: "manufacturing", title: "Manufacturing & Processing", image: "https://images.unsplash.com/photo-1720036236697-018370867320?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" },
  { id: "mining", title: "Mining Support Services", image: "https://images.unsplash.com/photo-1587919968590-fbc98cea6c9a?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" },
  { id: "construction", title: "Engineering & Construction", image: "https://images.unsplash.com/photo-1550985543-49bee3167284?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" },
  { id: "energy", title: "Energy & Resources", image: "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85" },
];

export const GALLERY = [
  "/uploads/mim-shaft-rebuild-2.jpg",
  "/uploads/mim-machined-bracket.jpg",
  "/uploads/mim-crankshaft.jpg",
  "/uploads/mim-tooling-rig.jpg",
  "/uploads/mim-shaft-rebuild-1.jpg",
  "https://images.unsplash.com/photo-1711418235334-8895331a6cf9?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  "https://images.unsplash.com/photo-1641893823219-38b433f736c0?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  "https://images.unsplash.com/photo-1666634157070-6fd830fb5672?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  "https://images.unsplash.com/photo-1564182998523-6923112e7d6b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  "https://images.unsplash.com/photo-1501516069922-a9982bd6f3bd?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
  "https://images.unsplash.com/photo-1720036237182-5e0adada1873?crop=entropy&cs=srgb&fm=jpg&w=1200&q=85",
];

export const MIM_PHOTOS = {
  hero: "/uploads/mim-tooling-rig.jpg",
  about: "/uploads/mim-shaft-rebuild-2.jpg",
  motor: "/uploads/mim-crankshaft.jpg",
  machining: "/uploads/mim-machined-bracket.jpg",
  fitting: "/uploads/mim-shaft-rebuild-1.jpg",
};

export const TESTIMONIALS = [
  {
    quote: "MIM stepped in when our gearbox failed on a Friday afternoon. New shaft machined, fitted and back running by Monday lunch. That kind of turnaround is gold to us.",
    author: "Maintenance Manager",
    role: "WA Recycling Operator",
  },
  {
    quote: "Their motor component work is tight — we've sent dozens of housings and shafts through and the tolerances come back clean every time. Communication is excellent.",
    author: "Workshop Supervisor",
    role: "Tier-1 Civil Construction Brand",
  },
  {
    quote: "From one-off custom brackets to full fabricate-and-coat packages, MIM handles it end-to-end. We don't have to chase three suppliers to get a job out.",
    author: "Project Engineer",
    role: "Mining Support Contractor",
  },
];

export const TRUST_BADGES = [
  "Tier-1 Civil Construction Brands",
  "WA Mining Contractors",
  "Waste & Recycling Operators",
  "Fleet & Transport Operators",
  "Manufacturing & Processing",
  "Energy & Resources",
];

export const MACHINES = {
  "CNC Machining": [
    { name: "Okuma CNC Spaceturn Lathe", model: "Spaceturn", specs: "Swing 400–500mm · Turning length up to 1,000mm · Soft & hard jaws · Full tooling · High-accuracy controls" },
    { name: "Haas CNC Vertical Machining Center", model: "4th Axis VMC", specs: "≈1000mm X · ≈500mm Y · 4th axis simultaneous · CAMWorks · 315mm chuck · Soft & hard jaws" },
  ],
  "Conventional Lathes": [
    { name: "HMT Lathe", model: "—", specs: "Conventional centre lathe" },
    { name: "Toss Lathe", model: "—", specs: "Conventional centre lathe" },
    { name: "RYZAN Lathe", model: "1M63 × 3m", specs: "Heavy-duty · Up to 3m between centres" },
    { name: "Dashan Champion Lathe", model: "Metric", specs: "Precision metric centre lathe" },
  ],
  "Milling": [
    { name: "KRM / Kingrich Mill", model: "—", specs: "Conventional milling" },
    { name: "Hafco Mill", model: "BM-70VE", specs: "90° milling head & arbour kit" },
  ],
  "Drilling": [
    { name: "HMT Radial Drill", model: "—", specs: "Radial arm drilling" },
    { name: "Bench Drill Press", model: "×3", specs: "Three units for general drilling" },
  ],
  "Specialized Work": [
    { name: "Slotter", model: "10\" stroke", specs: "Keyways and internal shapes" },
    { name: "Horizontal Borer", model: "—", specs: "Heavy boring operations" },
    { name: "Vertical Borer", model: "—", specs: "Large-diameter vertical boring" },
    { name: "Geocam Bandsaw", model: "—", specs: "460 × 490mm capacity" },
    { name: "Surface Grinder", model: "—", specs: "Precision flat grinding" },
    { name: "Broaching Press", model: "—", specs: "20-tonne capacity" },
    { name: "Arbor Press", model: "—", specs: "3-tonne capacity" },
    { name: "Hydraulic Press", model: "—", specs: "130-tonne capacity" },
    { name: "DEMAG Overhead Crane", model: "—", specs: "5-tonne capacity" },
    { name: "EDM Tap Burner", model: "300–3000W", specs: "Tap removal M2–M36 without damaging components" },
    { name: "Broaches — Metric", model: "—", specs: "Sizes up to 25mm" },
    { name: "Broaches — Imperial Keyway", model: "—", specs: "Sizes up to 3/4\"" },
  ],
  "Welding": [
    { name: "WIA 325 MIG Welder", model: "325", specs: "Heavy-duty MIG welding" },
    { name: "Lincoln V160TP TIG/Stick", model: "V160TP", specs: "Precision TIG and stick welding" },
    { name: "Lincoln 455 REDI-MIG", model: "455", specs: "Industrial MIG welding" },
    { name: "Welding Rotator Positioner", model: "—", specs: "220V powered positioner" },
    { name: "Oxy-Acetylene Kit", model: "—", specs: "Cutting and gas welding" },
  ],
  "Fabrication Tools": [
    { name: "Linisher / Grinder", model: "14\"", specs: "Surface finishing" },
    { name: "Drop Saw", model: "14\"", specs: "Material cutting" },
    { name: "Bar Bender", model: "—", specs: "Forming and bending" },
    { name: "Bench Grinder", model: "8\"", specs: "Tool sharpening" },
    { name: "Miscellaneous Tooling, Clamps & Extractor", model: "—", specs: "General fabrication" },
  ],
  "Precision Measuring": [
    { name: "Mitutoyo Digital Callipers", model: "300mm", specs: "Calibrated digital measurement" },
    { name: "Bore Gauges", model: "—", specs: "Internal diameter measurement" },
    { name: "Vernier Callipers", model: "600mm & 1000mm", specs: "Large dimensional checks" },
    { name: "Outside Micrometres", model: "0–600mm", specs: "External precision" },
    { name: "Inside Micrometres", model: "50–1000mm", specs: "Internal precision" },
    { name: "Telescopic Gauges", model: "—", specs: "Bore measurement transfers" },
    { name: "Hardness Tester", model: "—", specs: "Material verification" },
  ],
};

export const SERVICE_TYPES = SERVICES.map((s) => s.title).concat(["Other / Not sure"]);
